<template>
<div class="container-fluid" id="post_wrap">
	
	<div v-if="post.title">
		
		<h5 class="row align-items-center">
			<div class="col-10 col-sm-9 d-flex align-items-center">
        <back-btn position="relative"></back-btn>
        <i :class="post.categories[post.category].icon" class="fa-1x ml-2 mr-1"></i> <span v-text="post.categories[post.category].title"></span>
			</div>
			<div class="col-1 col-sm-3 text-right gold add_post_btn">
				<router-link :to="'/forum/post_add/' + this.$store.state.category_slug" class="btn btn-sm btn-secondary gold">
					<i class="fas fa-plus"></i> <span class="d-none d-sm-inline">Start New Thread</span>
				</router-link>
			</div>
		</h5>

		
<!-- Original Post -->
		<b-card class="mb-1" border-variant="primary" header-bg-variant="primary">
		
			<template v-slot:header>
				<div class="row">
					
					<div class="col-12 col-md-8 text-left">
						<span v-text="post.title"></span>
						<div class="d-block d-md-none border-bottom"></div>
					</div>
					
					<div class="col-12 col-md-4 text-left text-md-right small">
						
						<post-pin v-if="is_admin == 1" :status="post.pinned" type="post" :id="post_id" highlight="text-white" />
						
						<i class="fas fa-user"></i> <span v-text="post.user_name" class="btn-link pointer text-white" @click="userProfile(post.user_id)"></span>  <i class="far fa-clock"></i> <span v-text="post.access.date"></span> - <span v-text="post.access.time"></span>
					</div>
				</div>
			</template>
			
				
			<b-card-body class="p-0">
				<p v-html="post.main_text"></p>
				
				<div
					v-if="(post.youtube && post.youtube.length > 0) || (post.vimeo && post.vimeo.length > 0)" 
					class=""
				>
					<video-embeds :embeddata="post" classW="col-md-4 mb-2" />
				</div>
				
				
				
				<div class="text-right">
					
					<b-button 
						v-if="(is_admin == 1) || user_id == post.user_id"
						variant="outline-info" 
						size="sm"
						@click="postEdit(post_id, 0)"
					><i class="fas fa-pen"></i> edit
					</b-button>
					
					<b-button 
						v-if="post.can_comment == 1"
						variant="outline-secondary" 
						size="sm"
						@click="postReply('post', post_id, 0)"
					><i class="fas fa-pen"></i> reply
					</b-button>
					<span v-else :id="'disabled-btn-' + post.id" class="d-inline-block" tabindex="0">
						<b-button 
							size="sm" 
							disabled 
							variant="outline-secondary"
							v-b-tooltip.hover 
							title=""
							style="pointer-events: none;"
						>
							<i class="fas fa-pen"></i> <small>edit</small>
						</b-button>
						<b-tooltip :target="'disabled-btn-' + post.id">
							Comments disabled for this post
						</b-tooltip>
					</span>
					
					
				</div>
			</b-card-body>
			
		</b-card>
		
		

		<div v-if="post.replies && post.replies.length > 0">
			
			<h5 class="gold">Replies</h5>
		
			<div v-for="R in post.replies" :key="R.id" :class="'R_' + R.id">
				
				<b-card class="reply mt-2 mb-1" :border-variant="R.highlight">
				
<!-- Original Post Replies -->				
					<div class="row">
						<div class="col-12 text-right small">
							
							<post-pin v-if="is_admin == 1" :status="R.pinned" type="reply" :id="R.id" />
							
							<i class="fas fa-user gold"></i> <span v-text="R.user_name" class="btn-link pointer  gold mr-2" @click="userProfile(R.user_id)"></span>
							<i class="far fa-clock"></i> <span v-text="R.access.date"></span> - <span v-text="R.access.time" class="mr-2"></span> 
							<span class="btn-link pointer gold" @click="postReply('reply', post_id, R.id)">
								<i class="fas fa-pen"></i> reply
							</span>
							<span 
								v-if="(is_admin == 1) || user_id == post.user_id"
								class="btn-link pointer text-info" @click="postEdit(post_id, R.id)">
								<i class="fas fa-pen"></i> edit
							</span>
							
							<br />
							<small v-text="'reply #' + R.id" title="Reply ID"></small>
							<small v-if="R.reply_id !== null" @click="scrollTo(R.reply_id)" class="gold pointer">
								- Posted in response to #<span v-text="R.reply_id"></span>
							</small>
						</div>
						
						<div class="col-md-12">
							<p><b v-text="R.title"></b> - <span v-html="R.main_text"></span></p>
						</div>
					</div>	
						
					<div
						v-if="(R.youtube && R.youtube.length > 0) || (R.vimeo && R.vimeo.length > 0)" 
						class=""
					>
						<video-embeds :embeddata="R" classW="col-md-4 mb-2" />
					</div>
					
	

				</b-card>
			</div>
		</div>

	</div>
	
	<div v-else>
		<div class="text-center my-2 p-2 gold">
			<b-spinner class="align-middle"></b-spinner>
			<br />
			<strong>Loading...</strong>
		</div>
	</div>
	

  
	
</div>
</template>


<script>
import axios from "axios";
import PostPin from '../../components/forum/PostPin.vue';
import VideoEmbeds from '../../components/forum/VideoEmbeds.vue';
import BackBtn from "@/components/BackBtn.vue";


export default {
	name: "Post",
	components:{
    BackBtn,
		PostPin,
		VideoEmbeds,
	},
	props: {
	},
	data() {
		return {
			post: [],
			session_id: this.$store.state.session_id,
			temp : null,
		}
	},
	computed:{
		post_id(){
			var post_id = 0;
			if(this.$route.params.post_id){
				post_id = Number(this.$route.params.post_id);
			}
			return post_id;
		},
    is_admin(){
      return this.$store.state.profile.is_admin
    },
    user_id(){
      return this.$store.state.profile.id
    }
  },
	methods:{
		
		goto_page(page){
			this.$router.push(page);
		},
		
		postEdit(post_id, reply_id){
			this.$router.push('/forum/post_edit/' + post_id + '/' + reply_id);
		},
		
		postGet(){
			let _this = this;

			let params = new URLSearchParams();
			params.append('token', this.session_id);
			params.append('type', 'single');
			params.append('post_id', this.post_id);
			params.append('increment', 1);

			axios({
				url: _this.$store.state.api_url + "forum/postsGet",
				params: params,

			}).then(function (response) {
				var post = Object.values(response.data.post);
				_this.post = post[0];
				_this.replyGet();
				
				document.title = _this.post.title + ' - iAMconnected Forum';
				
			}).catch(function (error) {
				console.log(error);
			});
		},
		
		postReply(type, post_id, reply_id){
			this.$router.push('/forum/post_reply/' + post_id + '/' + type + '/' + reply_id);
		},
		
		replyGet(){
			let _this = this;

			let params = new URLSearchParams();
			params.append('token', this.session_id);
			params.append('forum_id', this.post_id);

			axios({
				url: _this.$store.state.api_url + "forum/replyGet",
				params: params,

			}).then(function (response) {
				var replies = Object.values(response.data.replies);
				_this.post.replies = replies;
				
			}).catch(function (error) {
				console.log(error);
			});
		},
		
		scrollTo(reply_id){
			const el = this.$el.getElementsByClassName("R_" + reply_id)[0];
			if(el){
				this.post.replies.forEach(function(obj) {
					if(parseInt(obj.id) === parseInt(reply_id)) {
						obj.highlight = 'primary';
					} else {
						obj.highlight = '';
					}
				});
				el.scrollIntoView({behavior: 'smooth'});
			}
		},
		
		userProfile(user_id){
			console.log('userProfile:' + user_id);
		},
		
	},
	mounted() {
		this.postGet();
	},
	watch: {
	}
	
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card.reply.border-primary {
	border-width: 3px;
}

</style>
